/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeClipSchema } from '../challenge-clip-schema';

export const listChallengeClipsResponseDataSchema = z.array(challengeClipSchema);

export type IListChallengeClipsResponseData = z.infer<typeof listChallengeClipsResponseDataSchema>;

export const listChallengeClipsResponseSchema = createApiResponseSchema(
  listChallengeClipsResponseDataSchema,
) as z.ZodSchema<IAPI<IListChallengeClipsResponseData>>;

export type IListChallengeClipsResponse = IAPI<IListChallengeClipsResponseData>;
